import React, { useState } from "react";

// Alcuni file cliente hanno più fogli (es. un primo foglio di copertina/
// riepilogo e i dati veri più avanti): senza chiedere non c'è modo di
// indovinare quale usare, quindi questo modale blocca il flusso finché
// l'utente non sceglie esplicitamente. Stesso linguaggio visivo di
// EstrazioneModal/DivisioneModal.
export default function SceltaFoglioModal({ nomeFile, fogli, onScegli, onAnnulla }) {
  const [scelto, setScelto] = useState(fogli[0]);

  return (
    <div
      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, fontFamily: "Inter, sans-serif" }}
      onClick={onAnnulla}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "var(--cf-bg-card)", borderRadius: "16px", width: "440px", maxWidth: "92vw", maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.45)" }}
      >
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)", padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "20px", lineHeight: 1 }}>📑</span>
            <div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontWeight: 700, fontSize: "15px", letterSpacing: "1px", textTransform: "uppercase", color: "#f1f5f9" }}>
                Scegli il foglio
              </div>
              <div style={{ fontFamily: "'Roboto Mono', Consolas, monospace", fontSize: "11px", color: "var(--cf-text-faint)", letterSpacing: "0.3px", marginTop: "3px" }}>
                {nomeFile}
              </div>
            </div>
          </div>
          <button className="cf-btn" onClick={onAnnulla} style={{ border: "none", background: "rgba(255,255,255,0.08)", borderRadius: "6px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", cursor: "pointer", color: "#cbd5e1", lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "24px", overflowY: "auto" }}>
          <p className="testo-secondario" style={{ marginTop: 0 }}>
            Questo file contiene più fogli: scegli quello con i dati da mappare.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {fogli.map((f) => (
              <label
                key={f}
                style={{
                  display: "flex", alignItems: "center", gap: "10px", padding: "10px 12px", borderRadius: "8px",
                  border: scelto === f ? "1px solid #1e3a8a" : "1px solid var(--cf-border-strong)",
                  backgroundColor: scelto === f ? "rgba(30, 58, 138, 0.12)" : "var(--cf-bg-subtle)",
                  cursor: "pointer",
                }}
              >
                <input type="radio" name="foglio-scelto" checked={scelto === f} onChange={() => setScelto(f)} />
                {f}
              </label>
            ))}
          </div>
        </div>

        <div style={{ padding: "16px 24px", borderTop: "1px solid var(--cf-border)", display: "flex", justifyContent: "flex-end", gap: "10px", flexShrink: 0 }}>
          <button onClick={onAnnulla}>Annulla</button>
          <button className="btn-primario" onClick={() => onScegli(scelto)}>Usa questo foglio</button>
        </div>
      </div>
    </div>
  );
}
